export const SHOW_PRO_MIGRATION_LS_KEY = 'brief_creation:job_post_migration_screen_declined';
